import { operationTypesConfig } from '../components/Steps/Price/priceConfig';
import { formatNumberToInt } from './numberFormatHelper';

const EXPENSES_FEATURE_ID = 'CFT6';
const IPTU_FEATURE_ID = 'CFT400';
const CREDIT_ACCEPTANCE_FEATURE_ID = '1000001';

function bodyManagerPriceStep(
  data,
  formValues,
  portalsWithCreditAcceptance,
  portalWithIPTU = false,
  isPortalWithMultipleCurrency = false
) {
  const body = {};
  const pricesByOpType =
    formValues?.map(op => {
      const pricesByOp = [];

      op.prices.forEach(price => {
        // si es un pais sin doble precio o la moneda no es dolares, cargo el precio normal
        if (price.currency !== 'USD' || !isPortalWithMultipleCurrency) {
          pricesByOp.push({
            currency: price.currency,
            amount: data[operationTypesConfig[op.operation_type]]
          });
        }
        // Si estamos en un portal de doble precio cargo el segundo precio en USD ( si existe )
        const secondPriceValue = data[operationTypesConfig[op.operation_type] + '-second'];
        if (
          isPortalWithMultipleCurrency &&
          price.currency !== 'USD' &&
          secondPriceValue !== null &&
          secondPriceValue !== undefined
        ) {
          pricesByOp.push({
            currency: 'USD',
            amount: formatNumberToInt(secondPriceValue)
          });
        }
      });

      return {
        operation_type: op.operation_type,
        prices: pricesByOp
      };
    }) || [];

  body.price_operation_type = pricesByOpType;
  body.features = [
    {
      feature_id: EXPENSES_FEATURE_ID,
      value: data.expenses
    }
  ];

  if (portalsWithCreditAcceptance) {
    body.features.push({
      feature_id: CREDIT_ACCEPTANCE_FEATURE_ID,
      value: data.creditAcceptance
    });
  }

  if (portalWithIPTU) {
    const formattedIPTU = data.IPTU ? formatNumberToInt(data.IPTU) : 0;
    body.features.push({
      feature_id: IPTU_FEATURE_ID,
      value: formattedIPTU
    });
  }

  return body;
}

export { bodyManagerPriceStep };
